import { AxiosError } from "axios";

const isNetworkError = (error: AxiosError) => {
  return error?.code === "ERR_NETWORK" || !navigator.onLine;
};

export { isNetworkError };
